// extracted by mini-css-extract-plugin
export default {"btn":"Button3_btn__lbJ9X"};